@if (_isUserInfoLoading) {
  <div class="elem-skeletons square-divs" style="display: flex">
    <ddc-loading-skeleton></ddc-loading-skeleton>
  </div>
} @else {
  <div class="base-cont">
    <!-- ! Header -->
    <div class="profile-container">
      <ddc-user-profile-card
        [_bio]="_bio"
        [_city]="_city"
        [_country]="_country"
        [_dics_count]="_dics_count"
        [_favLanguage1]="_favLanguage1"
        [_favLanguage2]="_favLanguage2"
        [_favLanguage3]="_favLanguage3"
        [_followers_count]="_followers"
        [_following_count]="_following"
        [_isFollowed]="_isFollowed"
        [_isOwnProfile]="_isOwnProfile"
        [_isVerified]="_isVerified"
        [_pairs_count]="_pairs_count"
        [_subscription]="_userSubscription"
        [_username]="_username"
        [_userProfilePic]="_userProfilePic"
        [_words_count]="_words_count"
        (editProfilePicture)="openProfilePictureDialog()"
        (followToggle)="onFollowToggle($event)"
      ></ddc-user-profile-card>
    </div>
    <!-- ! Chips -->
    <div class="user-profile-tabs-container">
      <div class="tabs-button-row">
        <ddc-tabs-chips
          [tabs]="[
            { key: 'words', label: 'Words', icon: _iconNames.WORD, selected: _tabUI.words.isSelected },
            { key: 'pairs', label: 'Pairs', icon: _iconNames.PAIR, selected: _tabUI.pairs.isSelected },
            {
              key: 'dictionaries',
              label: 'Dictionaries',
              icon: _iconNames.DICTIONARY,
              selected: _tabUI.dictionaries.isSelected,
            },
            { key: 'notes', label: 'Notes', icon: _iconNames.NOTE, selected: _tabUI.notes.isSelected },
            { key: 'quizzes', label: 'Quizzes', icon: _iconNames.QUIZ, selected: _tabUI.quizzes.isSelected },
            { key: 'figures', label: 'Figures', icon: _iconNames.FIGURE, selected: _tabUI.figures.isSelected },
          ]"
          [theme]="_isLightTheme ? 'light' : _isDarkTheme ? 'dark' : 'paper'"
          (tabClick)="clickedChip($event)"
        ></ddc-tabs-chips>
      </div>
    </div>
    <div class="user-profile-content-container">
      <!-- ! Words -->
      <div class="lib-words-container" *ngIf="_tabUI.words.isSelected">
        <div class="words-content">
          <div class="word-content-main" *ngIf="!_tabUI.words.isLoading">
            <div
              *ngIf="_words?.length > 0"
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="500"
              (scrolled)="onTabScroll('words')"
            >
              <div *ngFor="let word of _words; let i = index" style="margin: 10px">
                <ddc-content-card
                  [content]="word"
                  (clicked)="openReadDialog('words', i)"
                  (deleteClicked)="openDeleteDialog('words', i)"
                  (editClicked)="openEditDialog('words', i)"
                ></ddc-content-card>
              </div>
            </div>
            <!-- Info at bottom -->
            <div class="word-info-label" *ngIf="(_totalCounts['words'] || 0) > 10">
              <ng-lottie
                *ngIf="!_tabUI.words.end && !_tabUI.words.scrollLoading"
                width="30px"
                [options]="scroll_options"
              ></ng-lottie>
              <ng-lottie *ngIf="_tabUI.words.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
              <mat-icon *ngIf="_tabUI.words.end && !_tabUI.words.scrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
                _tabUI.words.pageInfoLabel
              }}
            </div>
            <!-- No words -->
            <ddc-not-available *ngIf="_words.length === 0" [_elem]="'Word'"></ddc-not-available>
          </div>
        </div>
        <div class="word-skeletons elem-skeletons" *ngIf="_tabUI.words.isLoading">
          <ddc-loading-skeleton></ddc-loading-skeleton>
        </div>
        <div *ngIf="_tabUI.words.isEmpty">{{ _tabUI.words.fetchError }}</div>
      </div>
      <!-- ! Pairs -->
      <div class="lib-pairs-container" *ngIf="_tabUI.pairs.isSelected">
        <div class="pairs-content">
          <div class="pair-content-main" *ngIf="!_tabUI.pairs.isLoading">
            <div
              *ngIf="_pairs?.length > 0"
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="500"
              (scrolled)="onTabScroll('pairs')"
            >
              <div *ngFor="let pair of _pairs; let i = index" style="margin: 10px">
                <ddc-content-card
                  [content]="pair"
                  (clicked)="openReadDialog('pairs', i)"
                  (deleteClicked)="openDeleteDialog('pairs', i)"
                  (editClicked)="openEditDialog('pairs', i)"
                ></ddc-content-card>
              </div>
            </div>
            <!-- Info at bottom -->
            <div class="dictionary-info-label" *ngIf="(_totalCounts['pairs'] || 0) > 10">
              <ng-lottie
                *ngIf="!_tabUI.pairs.end && !_tabUI.pairs.scrollLoading"
                width="30px"
                [options]="scroll_options"
              ></ng-lottie>
              <ng-lottie *ngIf="_tabUI.pairs.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
              <mat-icon *ngIf="_tabUI.pairs.end && !_tabUI.pairs.scrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
                _tabUI.pairs.pageInfoLabel
              }}
            </div>
            <!-- No pairs -->
            <ddc-not-available *ngIf="_pairs.length === 0" [_elem]="'Pair'"></ddc-not-available>
          </div>
        </div>
        <div class="pair-skeletons elem-skeletons" *ngIf="_tabUI.pairs.isLoading">
          <ddc-loading-skeleton></ddc-loading-skeleton>
        </div>
        <div *ngIf="_tabUI.pairs.isEmpty">{{ _tabUI.pairs.fetchError }}</div>
      </div>
    </div>
    <!-- ! Dictionaries -->
    <div class="lib-dictionaries-container" *ngIf="_tabUI.dictionaries.isSelected">
      <div class="dictionaries-content">
        <div class="dictionaries-content-main" *ngIf="!_tabUI.dictionaries.isLoading">
          <div
            *ngIf="_dictionaries?.length > 0"
            infiniteScroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="500"
            (scrolled)="onTabScroll('dictionaries')"
          >
            <div *ngFor="let dictionary of _dictionaries; let i = index" style="margin: 10px">
              <ddc-content-card
                [content]="dictionary"
                [dynamicRoute]="'/library/dic/' + dictionary.id + '/' + dictionary.owner.username"
                (deleteClicked)="openDeleteDialog('dictionaries', i)"
              ></ddc-content-card>
            </div>
          </div>
          <!-- Info at bottom -->
          <div class="dictionary-info-label" *ngIf="(_totalCounts['dictionaries'] || 0) > 10">
            <ng-lottie
              *ngIf="!_tabUI.dictionaries.end && !_tabUI.dictionaries.scrollLoading"
              width="30px"
              [options]="scroll_options"
            ></ng-lottie>
            <ng-lottie *ngIf="_tabUI.dictionaries.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
            <mat-icon *ngIf="_tabUI.dictionaries.end && !_tabUI.dictionaries.scrollLoading">fact_check</mat-icon
            >&nbsp;&nbsp;{{ _tabUI.dictionaries.pageInfoLabel }}
          </div>
          <ddc-not-available *ngIf="_dictionaries.length === 0" [_elem]="'Dictionary'"></ddc-not-available>
        </div>
      </div>
      <div class="_dictionary-skeletons elem-skeletons" *ngIf="_tabUI.dictionaries.isLoading">
        <ddc-loading-skeleton></ddc-loading-skeleton>
      </div>
      <div *ngIf="_tabUI.dictionaries.isEmpty">{{ _tabUI.dictionaries.fetchError }}</div>
    </div>
    <!-- ! Notes -->
    <div class="lib-notes-container" *ngIf="_tabUI.notes.isSelected">
      <div class="notes-content">
        <div class="notes-content-main" *ngIf="!_tabUI.notes.isLoading">
          <div
            *ngIf="_notes?.length > 0"
            infiniteScroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="500"
            (scrolled)="onTabScroll('notes')"
          >
            <div *ngFor="let note of _notes; let i = index" style="margin: 10px">
              <ddc-content-card
                [content]="note"
                (clicked)="openReadDialog('notes', i)"
                (deleteClicked)="openDeleteDialog('notes', i)"
                (editClicked)="openEditDialog('notes', i)"
              ></ddc-content-card>
            </div>
          </div>
          <!-- Info at bottom -->
          <div class="dictionary-info-label" *ngIf="(_totalCounts['notes'] || 0) > 10">
            <ng-lottie
              *ngIf="!_tabUI.notes.end && !_tabUI.notes.scrollLoading"
              width="30px"
              [options]="scroll_options"
            ></ng-lottie>
            <ng-lottie *ngIf="_tabUI.notes.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
            <mat-icon *ngIf="_tabUI.notes.end && !_tabUI.notes.scrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
              _tabUI.notes.pageInfoLabel
            }}
          </div>
          <ddc-not-available *ngIf="_notes.length === 0" [_elem]="'Note'"></ddc-not-available>
        </div>
      </div>
      <div class="elem-skeletons" *ngIf="_tabUI.notes.isLoading">
        <ddc-loading-skeleton></ddc-loading-skeleton>
      </div>
      <div *ngIf="_tabUI.notes.isEmpty">{{ _tabUI.notes.fetchError }}</div>
    </div>
    <!-- ! Quizzes -->
    <div class="lib-quizzes-container" *ngIf="_tabUI.quizzes.isSelected">
      <div class="quizzes-content">
        <div class="quizzes-content-main" *ngIf="!_tabUI.quizzes.isLoading">
          <div
            *ngIf="_quizzes?.length > 0"
            infiniteScroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="500"
            (scrolled)="onTabScroll('quizzes')"
          >
            <div *ngFor="let quiz of _quizzes; let i = index" style="margin: 10px">
              <ddc-content-card
                [content]="quiz"
                (clicked)="openReadDialog('quizzes', i)"
                (deleteClicked)="openDeleteDialog('quizzes', i)"
                (editClicked)="openEditDialog('quizzes', i)"
              ></ddc-content-card>
            </div>
          </div>
          <!-- Info at bottom -->
          <div class="dictionary-info-label" *ngIf="(_totalCounts['quizzes'] || 0) > 10">
            <ng-lottie
              *ngIf="!_tabUI.quizzes.end && !_tabUI.quizzes.scrollLoading"
              width="30px"
              [options]="scroll_options"
            ></ng-lottie>
            <ng-lottie *ngIf="_tabUI.quizzes.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
            <mat-icon *ngIf="_tabUI.quizzes.end && !_tabUI.quizzes.scrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
              _tabUI.quizzes.pageInfoLabel
            }}
          </div>
          <ddc-not-available *ngIf="_quizzes.length === 0" [_elem]="'Quiz'"></ddc-not-available>
        </div>
      </div>
      <div class="elem-skeletons" *ngIf="_tabUI.quizzes.isLoading">
        <ddc-loading-skeleton></ddc-loading-skeleton>
      </div>
      <div *ngIf="_tabUI.quizzes.isEmpty">{{ _tabUI.quizzes.fetchError }}</div>
    </div>
    <!-- ! Figures -->
    <div class="lib-figures-container" *ngIf="_tabUI.figures.isSelected">
      <div class="figures-content">
        <div class="figures-content-main" *ngIf="!_tabUI.figures.isLoading">
          <div
            *ngIf="_figures?.length > 0"
            infiniteScroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="500"
            (scrolled)="onTabScroll('figures')"
          >
            <div *ngFor="let figure of _figures; let i = index" style="margin: 10px">
              <ddc-content-card
                [content]="figure"
                (clicked)="openReadDialog('figures', i)"
                (deleteClicked)="openDeleteDialog('figures', i)"
                (editClicked)="openEditDialog('figures', i)"
              ></ddc-content-card>
            </div>
          </div>
          <!-- Info at bottom -->
          <div class="dictionary-info-label" *ngIf="(_totalCounts['figures'] || 0) > 10">
            <ng-lottie
              *ngIf="!_tabUI.figures.end && !_tabUI.figures.scrollLoading"
              width="30px"
              [options]="scroll_options"
            ></ng-lottie>
            <ng-lottie *ngIf="_tabUI.figures.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
            <mat-icon *ngIf="_tabUI.figures.end && !_tabUI.figures.scrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
              _tabUI.figures.pageInfoLabel
            }}
          </div>
          <ddc-not-available *ngIf="_figures.length === 0" [_elem]="'Figure'"></ddc-not-available>
        </div>
      </div>
      <div class="elem-skeletons" *ngIf="_tabUI.figures.isLoading">
        <ddc-loading-skeleton></ddc-loading-skeleton>
      </div>
      <div *ngIf="_tabUI.figures.isEmpty">{{ _tabUI.figures.fetchError }}</div>
    </div>
  </div>
}
